import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Banner() {
  return (
    <section className="banner_h100 salah_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="logo_nurs">
              <StaticImage
                src="../../../images/case-studies/selah/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={216}
                height={77}
              />
            </div>
            <h1>The Concept Behind Selah</h1>
            <p>
              Selah is a social app designed to connect and interact with
              friends and family. It's a dedicated platform to socialize, chat,
              and share media with your loved ones.
            </p>
            <p>
              TekRevol partnered with the client to build a UX-focused,
              minimalistic social application for iOS and Android where people
              can interact with the ones that matter the most, like family,
              friends, and other close acquaintances.
            </p>
            <div className="banner_btn">
              <Link
                to="https://play.google.com/store/apps/details?id=com.selahtech.app"
                rel="noopener noreferrer"
                target="_blank"
              >
                <StaticImage
                  src="../../../images/case-studies/selah/google-store.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={202}
                  height={76}
                />
              </Link>
              <Link
                to="https://apps.apple.com/us/app/selah/id1617474202"
                rel="noopener noreferrer"
                target="_blank"
              >
                <StaticImage
                  src="../../../images/case-studies/selah/app-store.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={207}
                  height={76}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center my-auto"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/selah/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={619}
                height={621}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
